import { render, staticRenderFns } from "./OrganisationForm.vue?vue&type=template&id=41690dd7&scoped=true&"
import script from "./OrganisationForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=41690dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41690dd7",
  null
  
)

export default component.exports